<template>
  <div id="system-base-menu">
    <div class="bg" />
    <template v-for="(menuItem, index) in menuList">
      <div
        v-if="showMenu(menuItem)"
        :key="index"
        :style="{'width':'100%', 'border-bottom': menuItem.level === 1 && index !== (menuList.length-1)? '2px solid rgba(72, 140, 232, 0.4)' : '', 'border-top': menuItem.level != 1 ? '1px solid #7A869E' : '', 'padding': '5px 0', 'padding-left': menuItem.menu_pid === 0 ? '' : menuItem.level * 20 + 'px'}"
      >
        <el-row>
          <el-col :span="12">
            <div class="auth-module-title">
              {{ menuItem.menu_pid > 0 ? (language == 'zh' ? menuItem.menu_cn_name : menuItem.menu_en_name) : (language == 'zh' ? menuItem.menu_cn_name : menuItem.menu_en_name) }}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-checkbox-group v-model="authCodes" :disabled="modalFlag===3" @change="updateCheckAuth">
            <el-row v-for="auth in menuItem.sys_auth_info" :key="auth.auth_code" :span="8"><div>
              <el-checkbox :label="auth.auth_code" size="medium" class="checkboxItem" :disabled="lockedAuths.indexOf(auth.auth_code) !== -1 && modalFlag===4">{{ language == 'zh' ? auth.auth_cn_name : auth.auth_en_name }}</el-checkbox>
            </div></el-row>
            <!-- <el-col :span="12" style="text-align: right"><div v-if="showUpdateBtn">
              <el-button type="primary" size="mini" @click="updateMenuMatch(menuItem)">{{ $t('components.update') }}</el-button>
            </div></el-col> -->
          </el-checkbox-group>
          <el-col>
            <template v-if="menuItem.children && menuItem.children.length > 0">
              <system-mch-menu :menu-list="menuItem.children" :auth-list="authCodes" :locked-code-list="lockedAuths" :modal-flag="modalFlag" />
            </template>
          </el-col>
        </el-row>
      </div>
    </template>

  </div>
</template>

<script>

export default {
  name: 'SystemMchMenu',
  components: {
    // UpdateMenuModal: () => import ('../Modal/UpdateMenuModal'),
  },
  props: {
    menuList: {
      type: Array,
      required: true
    },
    authList: {
      type: Array,
      required: false
    },
    modalFlag: {
      type: Number,
      required: false,
      default: function() {
        return 0
      }
    },
    lockedCodeList: {
      type: Array,
      default: function() {
        return []
      },
      required: false
    }
  },
  data() {
    return {
      authCodes: JSON.parse(JSON.stringify(this.authList)),
      lockedAuths: JSON.parse(JSON.stringify(this.lockedCodeList))
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    showUpdateBtn() {
      return this.$route.name === 'System_Menu_List'
    },
    showMenu() {
      return function(menuItem) {
        if (this.$store.getters.curCountry.country_code === 'MY' && menuItem.menu_code === 'MENU_P_SEND_PAYMENTS') {
          return false
        }
        return true
      }
    }
  },
  watch: {
    authList: {
      handler: function(newVal) {
        this.authCodes = newVal
      },
      deep: true
    },
    lockedCodeList: {
      handler: function(newVal) {
        this.lockedAuths = newVal
      },
      deep: true
    },
    modalFlag: {
      handler: function(newVal) {
        this.modalFlag = newVal
      },
      deep: true
    }
  },
  mounted() {

  },
  methods: {
    handleClick(tab) {
      this.role = {
        role_id: null,
        checkedAuth: []
      }
    },
    getSystemRoleList() {},
    getRoleAuthList(roleId = 0) {

    },
    updateCheckAuth() {
      if (this.modalFlag === 1) {
        this.$bus.emit('UPDATE_CHECK_AUTH_ADD_MODAL', this.authCodes)
      } else if (this.modalFlag === 2 || this.modalFlag === 4) {
        this.$bus.emit('UPDATE_CHECK_AUTH_MODIFY_MODAL', this.authCodes)
      } else if (this.modalFlag === 3) {
        this.$bus.emit('UPDATE_CHECK_AUTH_ASSIGN_MODAL', this.authCodes)
      } else {
        this.$bus.emit('UPDATE_CHECK_AUTH', this.authCodes)
      }
    },
    showAddMenuModal() {
      // this.$refs.addRoleRef.changeModalStatus(true)
    },
    handleChangeRole() {
      this.getRoleAuthList(this.role.role_id)
    },
    updateMenuMatch(item) {
      this.$bus.emit('SHOW_MENU_MODAL', { flag: true, item: item })
    }
  }
}
</script>

<style scoped>
#system-base-menu{
  width: 100%;
  line-height: 24px;
}
#system-base-menu ::v-deep .el-checkbox__label{
  font-size: 12px;
}
.auth-module-title{
  color: #364250;
  font-size: 14px;
  font-weight: 600;
  margin: 5px 0;
}

.search-btn {
  margin-left: 10px;
}
.add-btn{
  color: #fff;
}
.el-radio-group > div {
  margin: 10px;
}
/* .bg{
  position: absolute;
  top: 0;
  right: 0;
  width: 217px;
  height: 172px;
  background: url('~@/assets/ezpay/bg_logo_auth.png') no-repeat;
  background-size: 217px 186px ;
} */

</style>
